import { InjectionToken } from "@angular/core";

export const BASE_URL = new InjectionToken<string>("BaseUrl");
